import styles from '../pages.module.scss';
import PlayerCard from '../../components/playerCard/playerCard';

interface Props {
  rosterMembers: any[];
}

const RosterMembers = ({ rosterMembers }: Props) => {
  const rosterMembersL = rosterMembers.length;

  const players =
    rosterMembersL > 0 ? (
      rosterMembers.map((obj: any) => {
        return (
          <PlayerCard
            key={`player-${obj.personId}`}
            data={obj}
            wtnData={obj.worldTennisNumbers}
          ></PlayerCard>
        );
      })
    ) : (
      <></>
    );

  return <div className={styles.players}>{players}</div>;
};

export default RosterMembers;
